import AddProduct from './AddProduct';
import CustomerForm from './Customer';
import OrderItems from './OrderItems';
import SubmitOrder from './SubmitOrder';
import Discount from './Discount';

export default function CreateWholesaleOrder() {


  return (
    <>
      <h2>Create Order</h2>
      <AddProduct  />
      <OrderItems />
      <Discount />
      <CustomerForm />
      <SubmitOrder />
    </>
  );
}
